import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import LeakCard from "@/components/feature/LeakCard";
import { leakEntries } from "@/mocks/leaks";

export default function LatestLeaks() {
  const cards = leakEntries.slice(0, 3);
  const rows = leakEntries.slice(3, 7);

  return (
    <section className="bg-background-100">
      <div className="wrap py-14 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            index="02"
            eyebrow="Latest Leaks"
            title="最新整理线索"
            desc="每条线索都标注了来源描述与可信等级。等级只是当前阶段的判断，会随着新信源的出现而调整。"
          />
          <Link
            to="/leaks"
            className="btn-base self-start bg-foreground-950 px-5 py-2.5 text-background-50 hover:bg-foreground-900"
          >
            进入线索库
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {cards.map((entry) => (
            <LeakCard key={entry.id} entry={entry} />
          ))}
        </div>

        <div className="mt-12 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
          <h3 className="mb-2 flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
            <span className="flex h-5 w-5 items-center justify-center text-primary-600">
              <i className="ri-file-list-2-line" />
            </span>
            本周陆续收录
          </h3>
          <div>
            {rows.map((entry) => (
              <LeakCard key={entry.id} entry={entry} layout="row" showCover={false} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}